import { useId, type ReactNode } from "react";
import s from "./ui.module.css";

interface Option<T extends string> {
  wert: T;
  label: string;
  /** Statt des Worts ein Symbol, das Wort bleibt für Screenreader (zum Beispiel Kacheln und Liste) */
  symbol?: ReactNode;
}

interface Props<T extends string> {
  legende: string;
  optionen: readonly Option<T>[];
  wert: T;
  onWechsel: (wert: T) => void;
  gesperrt?: boolean;
  legendeVersteckt?: boolean;
}

export function Segment<T extends string>({ legende, optionen, wert, onWechsel, gesperrt, legendeVersteckt = true }: Props<T>) {
  const name = useId();
  return (
    <fieldset className={s.segment} disabled={gesperrt}>
      <legend className={legendeVersteckt ? s.nurLeser : s.label}>{legende}</legend>
      {optionen.map((o) => (
        <label key={o.wert}>
          <input type="radio" name={name} value={o.wert} checked={o.wert === wert} onChange={() => onWechsel(o.wert)} />
          {o.symbol ? (
            <span title={o.label}>
              {o.symbol}
              <span className="nur-leser">{o.label}</span>
            </span>
          ) : (
            <span>{o.label}</span>
          )}
        </label>
      ))}
    </fieldset>
  );
}
